/* eslint-disable react/prop-types */
import React from 'react';

const InputBox = ({ className, children, ...props }) => {
  return (
    <div className={`bg-100 p-2 border rounded-3 ${className}`} {...props}>
      {children}
    </div>
  );
};

export default InputBox;
